import { render, staticRenderFns } from "./edit-mailbox.vue?vue&type=template&id=411f226c&scoped=true&"
import script from "./edit-mailbox.vue?vue&type=script&lang=js&"
export * from "./edit-mailbox.vue?vue&type=script&lang=js&"
import style0 from "./edit-mailbox.vue?vue&type=style&index=0&id=411f226c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f226c",
  null
  
)

export default component.exports